<template>
  <b-container class="w-75 border" fluid>
    <b-row class="justify-content-md-center text-center">
      <h3>가톨릭대학교인천성모병원장례식장</h3>
    </b-row>
    <b-row class="justify-content-md-center">
      <section class="mt10">
        <div class="fcBlack text-center">
          <p class="fsr1_4 mb05">07월 01일 별세</p>
          <h2 class="fsr2_2 fw600">故 홍길순 (46세)</h2>
        </div>
      </section>
    </b-row>
    <br/>
    <b-row class="border-bottom">
      <h4 class="sub_title">상주</h4>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold" offset-md="1">행인</b-col>
      <b-col cols="12" md="auto">홍길동</b-col>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold" offset-md="1">빈소</b-col>
      <b-col cols="12" md="auto">가톨릭대학교인천성모병원장례식장 1호</b-col>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold pt-2" offset-md="1">발인</b-col>
      <b-col col lg="auto">
        <b-row cols="" md="auto">2021년 07월 03일 (토요일)</b-row>
        <b-row cols="" md="auto">00시 00분 (발인 2일 전)</b-row>
      </b-col>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold" offset-md="1">장지</b-col>
      <b-col cols="12" md="auto">미정</b-col>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold" offset-md="1">상주말씀</b-col>
      <b-col cols="12" md="auto">주차는 영등포보건소 지하 주차장을 이용해주세요</b-col>
    </b-row>

    <br/>
    <b-row class="border-bottom">
      <h4 class="sub_title">오시는길</h4>
    </b-row>
    <b-row>
      <div id="map" style="width:100%; height:500px"></div>
    </b-row>
    <br/>
    <b-row class="border-bottom">
      <b-col col lg="3" class="fw-bold" offset-md="1">교통안내</b-col>
      <b-col col lg="3" class="fw-bold" offset-md="1">주차안내</b-col>
      <b-col col lg="3" class="fw-bold" offset-md="1">네비게이션</b-col>
    </b-row>

    <br/>

    <b-row class="border-bottom">
      <h4 class="sub_title">조문메세지(3)</h4>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold" offset-md="1">행인</b-col>
      <b-col cols="12" md="auto">삼가 고인의 명복을 빕니다. 삼가 고인의 명복을 빕니다. 삼가 고인의 명복을 빕니다.</b-col>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold" offset-md="1">행인</b-col>
      <b-col cols="12" md="auto">삼가 고인의 명복을 빕니다. 삼가 고인의 명복을 빕니다. 삼가 고인의 명복을 빕니다.</b-col>
    </b-row>
    <b-row class="border-bottom">
      <b-col col lg="2" class="fw-bold" offset-md="1">행인</b-col>
      <b-col cols="12" md="auto">삼가 고인의 명복을 빕니다. 삼가 고인의 명복을 빕니다. 삼가 고인의 명복을 빕니다.</b-col>
    </b-row>

    <br/>
    <b-row class="border-bottom justify-content-center">
        <b-col lg="4" class="pb-2"><b-button>글 남기기</b-button></b-col>
    </b-row>


    <br/>
    <b-row class="border-bottom justify-content-center">
      <b-col lg="4" class="pb-2"><b-button>앗1</b-button></b-col>
      <b-col lg="4" class="pb-2"><b-button>앗1</b-button></b-col>
      <b-col lg="4" class="pb-2"><b-button>앗1</b-button></b-col>
    </b-row>
  </b-container>

</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      map: null,
      fields: ['행인', 'last_name', 'age'],
      items: [
        { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
        { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
        { age: 89, first_name: 'Geneva', last_name: 'Wilson' }
      ]
    }
  },
  methods: {
    loginWithKakao() {
      window.Kakao.Auth.authorize({
        redirectUri: `${window.location.protocol}//${window.location.host}${window.location.pathname}`, // Require
      })
    },
    initMap() {
      const container = document.getElementById('map'); //지도를 담을 영역의 DOM 레퍼런스
      const options = { //지도를 생성할 때 필요한 기본 옵션
        center: new window.kakao.maps.LatLng(33.450701, 126.570667), //지도의 중심좌표.
        level: 3 //지도의 레벨(확대, 축소 정도)
      };
      this.map = new window.kakao.maps.Map(container, options); //지도 생성 및 객체 리턴
    }
  },
  created() {
    if (!window.Kakao.isInitialized()) {
      window.Kakao.init('bc686096e7d9fcf99c548e7c25d5b62d');
    }

    console.log(window.Kakao.isInitialized());
  },
  mounted() {

    if (!window.kakao || !window.kakao.maps) {
      const script = document.createElement("script");
      script.src = '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=bc686096e7d9fcf99c548e7c25d5b62d';
      script.addEventListener("load", () => {
        console.log('로딩')
        window.kakao.maps.load(this.initMap);
      });
      document.head.appendChild(script);
    } else {
      console.log('카카오지도객체있음')
      this.initMap();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
